import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { IoCalendarOutline, IoTimeOutline } from 'react-icons/io5';
import { TbSchool } from 'react-icons/tb';
import { PaymentModal } from '../../components/payment_modal';
import { UserContext } from '../../context/UserContext';

function ConfirmPrivateEnrollmentScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedClasses, setSelectedClasses] = useState(location.state.classes);
  const [totalAmount, seTotalAmount] = useState(0);
  const [canProceed, setCanProceed] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentCurrency, setCurrency] = useState('USD');
  const [cookies, setCookie, removeCookie] = useCookies();
  const { setTostMessage } = useContext(TostMessageContext)
  const [loading, setLoading] = useState(false);
  const {logOutFunction} = useContext(UserContext);
  const [showPaymentAccount, setShowPaymentAccount] = useState(false)

  useEffect(() => {
    let total = 0;
    for (var i=0; i < selectedClasses.length; i++) {
        total = total + parseInt(selectedClasses[i].amount * selectedClasses[i].duration);
    }
    seTotalAmount(total)
  }, [])

  useEffect(() => {
    let total = 0;
    for (var i=0; i < selectedClasses.length; i++) {
        total = total + parseInt(selectedClasses[i].amount * selectedClasses[i].duration);
    }
    seTotalAmount(total)
  }, [selectedClasses])

  const remove = async (group_id) => {
    const new_array = selectedClasses;
    const index = new_array.findIndex(item => item.group_id === group_id);
    if (index !== -1) {
        seTotalAmount(totalAmount - new_array[index].amount)
        new_array.splice(index, 1);
        if (new_array.length < 1) {
            setCanProceed(false)
        }
    }
    setSelectedClasses(new_array);
  }

  const makePayment = async (currency) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("selected_classes", JSON.stringify(selectedClasses));
    formData.append("currency", currency);
    console.log(currency);

    try {
        const response = await axios.post(base_url + '/subscription/initiate_private_payment.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            // setLoading(false);
            setTostMessage({
                messageType: "success",
                message: response.data.response,
            });
            // setShowPaymentAccount(true);
            window.open(response.data.payment_link, '_blank');
            // setTimeout(() => {
            //     navigate("/subscriptions");
            // }, 2000)
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const handleIncrease = (group_id, end_date) => {
    // setDuration(prev => prev + 1);
    const new_array = selectedClasses;
    const index = new_array.findIndex(item => item.booking_id === group_id);
     setSelectedClasses(prevItems => {
        const updatedItems = [...prevItems];
        const newData = {duration: updatedItems[index].duration + 1}
        updatedItems[index] = {
        ...updatedItems[index],
        ...newData
        };
        return updatedItems;
    });
  };

  const handleDecrease = (group_id) => {
    // setDuration(prev => (prev > 1 ? prev - 1 : 1));
    const new_array = selectedClasses;
    const index = new_array.findIndex(item => item.booking_id === group_id);
    if (selectedClasses[index].duration > 1) {
        setSelectedClasses(prevItems => {
            const updatedItems = [...prevItems];
            const newData = {duration: updatedItems[index].duration - 1}
            updatedItems[index] = {
            ...updatedItems[index],
            ...newData
            };
            return updatedItems;
        });
    }
  };

  const handleInputChange = (e, group_id, end_date) => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val) && val > 0) {
        const new_array = selectedClasses;
        const index = new_array.findIndex(item => item.booking_id === group_id);
        setSelectedClasses(prevItems => {
            const updatedItems = [...prevItems];
                const newData = {duration: val}
                updatedItems[index] = {
                ...updatedItems[index],
                ...newData
                };
                return updatedItems;
        });
    } else if (e.target.value === '') {
        const new_array = selectedClasses;
        const index = new_array.findIndex(item => item.group_id === group_id);
        setSelectedClasses(prevItems => {
            const updatedItems = [...prevItems];
            const newData = {duration: 0}
            updatedItems[index] = {
            ...updatedItems[index],
            ...newData
            };
            return updatedItems;
        });
    }
  };

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    <div className="w-full mx-auto p-6 bg-white rounded-xl shadow">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-sm lg:text-xl font-semibold">Total Selected</h2>
                            <div className="flex flex-col lg:flex-row items-end lg:items-center gap-4">
                                <span className="text-[17px] lg:text-[24px] font-bold"><span className="text-sm font-normal">Total: </span> ${totalAmount}</span>
                                <div>
                                    <ButtonSmall label={'Pay Online'} onPress={() => {setShowPaymentModal(true);setShowPaymentAccount(false); }} loading={false}/>
                                    {showPaymentModal && (
                                        <PaymentModal 
                                            amount={totalAmount}
                                            setCurrency={setCurrency}
                                            paymentCurrency={paymentCurrency}
                                            setShowPaymentModal={setShowPaymentModal}
                                            makePayment={makePayment}
                                            showPaymentAccount={showPaymentAccount}
                                            loading={loading}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="space-y-4 w-full">
                            {selectedClasses?.map((cls) => (
                            <div key={cls.id} className="flex flex-col lg:flex-row justify-between items-center p-4">
                                <div className='w-full lg:w-[50%] p-6 bg-gray-50 border border-1 rounded-[10px]'>
                                    <h3 className="font-bold">{cls.language}</h3>
                                    <div className="text-[14px] flex items-center gap-1 font-regular text-dark mt-1 flex flex-row">
                                        <IoTimeOutline />
                                        {cls?.schedule.map((time, idx) => (
                                            <span key={idx}>{time}, </span> 
                                        ))}
                                    </div>
                                    <ul className="text-[14px] font-regular text-dark mt-1 space-y-1">
                                        <li className="flex items-center gap-1">
                                            <TbSchool />
                                            <span>{cls.level_name}</span>
                                        </li>
                                        {/* <li className="flex items-center gap-1">
                                            <IoCalendarOutline />
                                            <span>{cls.start_date} - {cls.end_date}</span>
                                        </li> */}
                                    </ul>
                                </div>
                                <div className='flex flex-col mt-2 lg:mt-0 items-center justify-center'>
                                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-3 py-2 w-fit bg-white">
                                        <button
                                            onClick={() => handleDecrease(cls.booking_id)}
                                            className="text-lg font-bold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                                        >
                                            −
                                        </button>
                                        <input
                                            type="number"
                                            value={selectedClasses[selectedClasses.findIndex(item => item.booking_id === cls.booking_id)].duration}
                                            onChange={(e) => handleInputChange(e, cls.booking_id, cls.end_date)}
                                            className="w-12 text-center border-none focus:outline-none text-sm"
                                            min={1}
                                        />
                                        <button
                                            onClick={() => handleIncrease(cls.booking_id, cls.end_date)}
                                            className="text-lg font-bold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                                        >
                                            +
                                        </button>
                                    </div>
                                    <a className='text-sm mt-2'>Session(s)</a>
                                </div>
                                <div className="w-full lg:w-auto text-right flex flex-row justify-between lg:justify-center mt-2 lg:mt-0 items-center">
                                    <div className="font-bold text-[17px] lg:text-[24px]">${cls.amount * selectedClasses[selectedClasses.findIndex(item => item.booking_id === cls.booking_id)].duration} </div>
                                    <button onClick={() => remove(cls.booking_id)} className="ml-0 lg:ml-2 px-[2rem] lg:px-[3rem] py-[1rem] lg:py-[1.5rem] bg-red-600 text-white text-[15px] font-bold rounded hover:bg-red-700">
                                        Remove
                                    </button>
                                </div>
                            </div>
                            ))}
                        </div>
                        </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default ConfirmPrivateEnrollmentScreen;
